let API_BASE_FILTER_URL = "";

export const getApiBaseUrl = () => API_BASE_FILTER_URL;

const initConfig = async () => {
  const { API_URL } = await import("../../../configService").then((mod) =>
    mod.loadConfig()
  );
  API_BASE_FILTER_URL = API_URL;
};

const LOGIN = "/login";
const CHANGE_PASSWORD = "/UserChangePassword";
const REGISTER = "/register";
const GET_PASSWORD_POLICY = "/getPasswordPolicy";
const UPDATE_PASSWORD_POLICY = "/updatePasswordPolicy";
const GET_AHU_LIST = "/GetAHUMachines";
const ADD_AHU = "/api/AddAHU";
const EDIT_AHU = "/api/updateAHU";
const GET_USERS = "/GetUser";
const GET_AHU_FILTERS = "/GetAHUFilters";
const EDIT_AHU_FILTER = "/api/updateFilter";
const ADD_AHU_FILTER = "/api/AddAHUFilter";
const UPDATE_FILTER_STATUS = "/AHUFiltersUpdateStatus";
const PRINT_BARCODE = "/AHUFilterGenerateBarcode";
const GET_NOTIFICATIONS = "/getNotifications";
const GET_REPLACEMENT_LIST = "/api/getReplacementList";
const GET_DEVIATIONS_ALARMS = "/getDeviationsAlarms";
const GET_RETIREMENT_LIST = "/api/getRetirementList";
const GET_DASHBOARD = "/getDashboard";
const EDIT_USER = "/api/updateUserInfo";
const GET_ACTIVITIES = "/getActivities";
const GET_ACTIVITIESPG = "/getActivitiesPg";
const ADD_ACTIVITY = "/addActivity";
const GET_AHU = "/api/getAHUIds";
const GET_AHU_MACHINES_LIST = "/api/getAHUList";
const GET_ALL_USERS = "/api/getAllUsers";
const GET_ASSET_TYPE = "/api/getAssetType";
const ADD_ASSET_TYPE = "/api/AddAssetType";
const UPDATE_ASSET_TYPE = "/api/UpdateAssetType";
const UPDATE_ASSET_TYPE_STATUS = "/api/updateAssetTypestatus";
const GET_MAINTAIN_STAGES = "/api/getMaintenanceStages";
const GET_WASH_IN = "/api/getWashInReasons";
const ADD_WASH_IN = "/api/AddWashInReasons";
const UPDATE_WASH_IN = "/api/updateWashInReasons";
const UPDATE_WASHIN_STATUS = "/api/updateWashInReasonsstatus";
const GET_PRESSURES = "/api/getPressure";
const UPDATE_PRESSURE = "/api/updatePressure";
const GET_LOCATIONS = "/api/getlocations";
const ADD_LOCATION = "/api/addlocations";
const UPDATE_LOCATION = "/api/editlocations";
const UPDATE_LOCATION_STATUS = "/api/updatelocationsstatus";
const GET_WASH_EQUIP = "/api/getEquipments?Isdryer=0";
const UPDATE_WASH_EQUIP_STATUS = "/api/updateEquipmentsstatus";
const ADD_EQUIP = "/api/addEquipments";
const UPDATE_EQUIP = "/api/updateEquipments";
const GET_DRYER_EQUIP = "/api/getEquipments?Isdryer=1";
const GET_STAGE_COUNT = "/api/getStageCount";
const GET_ADMIN_DASHBOARD_COUNT = "/api/getAdminDashboardCount";
const GET_USER_DASHBOARD_COUNT = "/api/getUserDashboardCount";
const GET_BLOCKS = "/api/getLocationType";
const GET_BAR_GRAPH = "/api/getbarGraph";
const GET_EQUIPMENTS = "/api/getEquipments";
const GETMASTERSREASONS = "/api/GetMastersReasons";
const GETMASTERSPRESSURE = "/api/GetMastersPressure";
const UPDATEFILTERSTATUS = "/api/UpdateFilterStatus";
const GET_APPROVALS = "/api/getApprovalSetting";
const UPDATE_APPROVALS = "/api/updateApprovalSetting";
const GET_MENU = "/api/getmenu";
const GET_TASKS = "/api/GetTasks";
const GET_SCHEDULE = "/api/GetSchedules";
const ADD_PRINTER = "/api/addPrinter";
const UPDATE_PRINTER = "/api/updatePrinter";
const DELETE_PRINTER = "/api/deleteprinterIpAdress";
const GET_PRINTERS = "/api/getprinterIpAdress";
const GET_EQUIP = "/api/getPressureEquipments";
const GET_ROLES = "/api/getRoles";

export {
  initConfig,
  LOGIN,
  CHANGE_PASSWORD,
  REGISTER,
  GET_PASSWORD_POLICY,
  UPDATE_PASSWORD_POLICY,
  GET_AHU_FILTERS,
  EDIT_AHU_FILTER,
  ADD_AHU_FILTER,
  UPDATE_FILTER_STATUS,
  PRINT_BARCODE,
  GET_NOTIFICATIONS,
  GET_REPLACEMENT_LIST,
  GET_DEVIATIONS_ALARMS,
  GET_RETIREMENT_LIST,
  EDIT_USER,
  GET_AHU_LIST,
  ADD_AHU,
  EDIT_AHU,
  GET_USERS,
  GET_DASHBOARD,
  ADD_ACTIVITY,
  GET_ACTIVITIES,
  GET_ACTIVITIESPG,
  GET_AHU,
  GET_ALL_USERS,
  GET_AHU_MACHINES_LIST,
  GET_ASSET_TYPE,
  ADD_ASSET_TYPE,
  UPDATE_ASSET_TYPE,
  UPDATE_ASSET_TYPE_STATUS,
  GET_WASH_IN,
  ADD_WASH_IN,
  UPDATE_WASH_IN,
  UPDATE_WASHIN_STATUS,
  GET_PRESSURES,
  UPDATE_PRESSURE,
  GET_MAINTAIN_STAGES,
  GET_LOCATIONS,
  ADD_LOCATION,
  UPDATE_LOCATION,
  UPDATE_LOCATION_STATUS,
  GET_WASH_EQUIP,
  UPDATE_WASH_EQUIP_STATUS,
  GET_DRYER_EQUIP,
  ADD_EQUIP,
  UPDATE_EQUIP,
  GET_BLOCKS,
  GET_STAGE_COUNT,
  GET_ADMIN_DASHBOARD_COUNT,
  GET_USER_DASHBOARD_COUNT,
  GET_BAR_GRAPH,
  GETMASTERSREASONS,
  GETMASTERSPRESSURE,
  UPDATEFILTERSTATUS,
  GET_EQUIPMENTS,
  GET_APPROVALS,
  UPDATE_APPROVALS,
  GET_MENU,
  GET_TASKS,
  GET_SCHEDULE,
  ADD_PRINTER,
  UPDATE_PRINTER,
  DELETE_PRINTER,
  GET_PRINTERS,
  GET_EQUIP,
  GET_ROLES,
};
